<template>
  <div :class="`as-no-data ${modifyClass}`">
    <IconNoData />
    <h4>{{ title }}</h4>
  </div>
</template>

<script setup lang="ts">
import IconNoData from "~src/components/icons/IconNoData.vue";
interface IProps {
  modifyClass?: string;
  title?: string;
}

withDefaults(defineProps<IProps>(), {
  modifyClass: "",
  title: "Chưa có dữ liệu",
});
</script>

<script lang="ts">
export default {};
</script>
